module.exports = new __parcel__URL__("image_ko.9697a3fc.png").toString();